import { render, staticRenderFns } from "./pondAdd.vue?vue&type=template&id=d825f04c&scoped=true"
import script from "./pondAdd.vue?vue&type=script&lang=js"
export * from "./pondAdd.vue?vue&type=script&lang=js"
import style0 from "./pondAdd.vue?vue&type=style&index=0&id=d825f04c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d825f04c",
  null
  
)

export default component.exports